import { action } from '@ember/object';
import Component from '@glimmer/component';
import { service } from '@ember/service';
import type ProductModel from 'frontend/models/product';
import { tracked } from 'tracked-built-ins';
import type IntlService from 'ember-intl/services/intl';
import type ActionModel from 'frontend/models/action';
import type RouterService from '@ember/routing/router-service';
import type TagModel from 'frontend/models/tag';
import { TagTypes } from 'common/enums/tag-type.enum';

interface PagesCatalogProductArgs {
  model: ProductModel;
}

// eslint-disable-next-line ember/no-empty-glimmer-component-classes
export default class PagesCatalogProduct extends Component<PagesCatalogProductArgs> {
  @service declare intl: IntlService;
  @service declare router: RouterService;
  @tracked declare selectedDate: string;
  @tracked declare currentSlug: string;
  @tracked type: string = 'product';
  @tracked isOpenedModal = false;

  get isNotProduct(): boolean {
    return this.type !== 'product';
  }

  get tags() {
    return this.args.model.tags.filter(
      (tag: TagModel) => tag.type === TagTypes.One
    );
  }

  @action
  changeDate(value: ActionModel) {
    this.selectedDate = value.startAt;
    this.currentSlug = value.slug;
  }

  @action
  toggleModal() {
    this.isOpenedModal = !this.isOpenedModal;
  }

  @action async transitionToAction(slug?: string) {
    await this.router.transitionTo('catalog.action', slug ?? this.currentSlug);
  }
  @action async transitionToApply(slug: string) {
    await this.router.transitionTo('catalog.action.apply', slug);
  }
}
